import request from '@/utils/request'

// 分页查询教育名师
export function pageEduTeacher(data) {
  return request({
    url: '/biz/admin/edu/teacher/page',
    method: 'post',
    data: data
  })
}

// 教育名师详情
export function getEduTeacher(data) {
  return request({
    url: '/biz/admin/edu/teacher/detail',
    method: 'post',
    data: data
  })
}

// 新增教育名师
export function addEduTeacher(data) {
  return request({
    url: '/biz/admin/edu/teacher/add',
    method: 'post',
    data: data
  })
}

// 修改教育名师
export function updateEduTeacher(data) {
  return request({
    url: '/biz/admin/edu/teacher/edit',
    method: 'post',
    data: data
  })
}

// 删除教育名师
export function delEduTeacher(data) {
  return request({
    url: '/biz/admin/edu/teacher/delete',
    method: 'post',
    data: data
  })
}
